import {
  Box,
  FormControl,
  InputBase,
  MenuItem,
  Select,
  styled,
  Typography,
} from "@mui/material";
import { useRef, useState } from "react";
import DownArrow from "../../assets/SVG/downArrow";

export default function SelectInput({
  data,
  placeholder,
  width,
  setValue,
  value,
  valueInput,
  setValueInput,
}) {
  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
      borderRadius: 8,
      boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "solid 1px var(--emr-borderInput)",
      fontSize: 16,

      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:focus": {
        borderRadius: 8,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }));
  const refInput = useRef();

  const [input, setInput] = useState();
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <FormControl variant="standard">
      {!input && (
        <Select
          ref={refInput}
          IconComponent={(props) => {
            return (
              <Box
                // onClick={() => refInput.current.onClick}
                {...{ className: "", ...props }}
                position="absolute !important"
                top="calc(50% - 0.65em) !important"
                left="0 !important"
                right="auto !important"
                ml="10px !important"
              >
                <DownArrow />
              </Box>
            );
          }}
          value={value}
          onChange={handleChange}
          input={<BootstrapInput />}
          sx={{
            width: width ? width : "100px",
            "& .MuiSelect-select": {
              padding: "4px 10px 5px !important",
              color: "var(--emr-text-light)",
            },
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 40 * 4.5 + 30,
                width: 70,
                backgroundColor: "#F3F3F3",
                borderRadius: "8px",
              },
            },
          }}
          renderValue={(selected) => {
            if (value === 0 || value === undefined) {
              return (
                <Typography color={"var(--emr-disable)"}>
                  {placeholder}
                </Typography>
              );
            }

            return data.length > 0 && data[0]?.id
              ? data.find((itr) => itr.id === value)?.label
              : value;
          }}
        >
          {data.map((item) => (
            <MenuItem value={item?.id ? item.id : item}>
              {item?.label ? item.label : item}
            </MenuItem>
          ))}
        </Select>
      )}
      {input && (
        <InputBase
          value={valueInput}
          onChange={(e) => setValueInput(e.target.value)}
          autoFocus
          placeholder={placeholder}
          sx={{
            border: "solid 1px var(--emr-borderInput)",
            borderRadius: "8px",
            width: width ? width : "100px",
            px: "10px",
            boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            height: "46px",
          }}
        />
      )}
    </FormControl>
  );
}
